type RouteHandler = () => void;

export class Router {
    private routes: Map<string, RouteHandler> = new Map();

    constructor() {
        window.addEventListener("popstate", () => this.resolve());
    }

    on(path: string, handler: RouteHandler) {
        this.routes.set(path, handler);
    }

    private getRouteFromHash(): string {
        const hash = window.location.hash; // e.g. "#/some/route?query=123#fragment"

        // Remove the leading '#' if present
        const cleanHash = hash.startsWith('#') ? hash.slice(1) : hash;

        // Split off at '?' for query strings or '#' for fragments
        const route = cleanHash.split(/[?#]/)[0];

        return route;
    }


    public currentPath() {
        return this.getRouteFromHash();
    }

    public currentLocation() {
        return window.location.href;
    }

    //todo: lives here, but it could live somewhere else
    navigate(path: string) {
        history.pushState({}, "", path);
        this.resolve();
    }

    getQueryParams(): Record<string, string> {
        const hash = window.location.hash; // e.g. "#/me?user=a"
        const hashPath = hash.substring(1); // "/me?user=a"
        const [_, queryString] = hashPath.split('?');

        if (!queryString) return {};

        return Object.fromEntries(new URLSearchParams(queryString).entries());
    }

    resolve() {
        let path: string;
        
        path = window.location.href.replace(window.location.origin + "/#", "");
        path = window.location.href.replace(window.location.origin + "/", "");
        path = path.replace("#","");

        const pathName = path.split('?')[0];
        const handler = this.routes.get(pathName);

        handler?.();
    }
}
